<script setup lang="ts">
const props = defineProps<{
  /**
   * Label of the column
   */
  label: string;
}>();

const slots = defineSlots<{
  actions?(): unknown;
}>();
</script>

<template>
  <div class="onyx-component onyx-data-grid-header-cell">
    <span class="onyx-data-grid-header-cell__label">{{ props.label }}</span>
    <div v-if="slots.actions" class="onyx-data-grid-header-cell__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<style lang="scss">
@use "../../../styles/mixins/layers.scss";

.onyx-data-grid-header-cell {
  @include layers.component() {
    display: flex;
    align-items: center;
    gap: var(--onyx-density-xs);
    min-height: 1.5rem;

    &__actions {
      display: inline-flex;
      gap: var(--onyx-density-2xs);
    }
    &__label {
      max-width: 100%;
    }
  }
}
</style>
